import * as Yup from 'yup';

export const LoginSchema = Yup.object().shape({
  email: Yup.string()
    .email('Cette adresse est invalide.')
    .required("L'adresse e-mail est obligatoire."),
  // No length rule: the passwords set before the current rule still log in.
  password: Yup.string().required('Le mot de passe est obligatoire.'),
});
